/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBorderCorners = createReactComponent("outline", "border-corners", "IconBorderCorners", [["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-0" }], ["path", { "d": "M20 16v2a2 2 0 0 1 -2 2h-2", "key": "svg-1" }], ["path", { "d": "M8 20h-2a2 2 0 0 1 -2 -2v-2", "key": "svg-2" }], ["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-3" }]]);

export { IconBorderCorners as default };
//# sourceMappingURL=IconBorderCorners.mjs.map
